@if (iconName()) {
  <fu-icon
    class="custom-btn-icon"
    [iconName]="iconName()"
    [size]="size() === 'lg' ? '32' : '24'"
  />
}

<ng-content></ng-content>
